<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <svg viewBox="0 0 1024 1024" width="24" height="24">
                        <path d="M416 192V128h-32v64a96 96 0 0 1-192 0v-64h-32v64a128 128 0 0 0 256 0v-64zM896 192V128h-32v64a96 96 0 0 1-192 0v-64h-32v64a128 128 0 0 0 256 0v-64zM416 320v-64h-32v64a160 160 0 0 0 32 0zM608 320v-64h-32v64a160 160 0 0 0 32 0zM128 448v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V448a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32zM896 512H128v384h768V512z" fill="currentColor"/>
                    </svg>
                </div>
                <div class="header-text">
                    <h2>活动分类管理</h2>
                    <p>二级分类体系 · 层级结构维护</p>
                </div>
            </div>
            <div class="header-actions">
                <!-- 搜索区域 -->
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.activityClassName" placeholder="搜索分类名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn" @click="BoxOpen">
                    <i class="el-icon-plus"></i>
                    新增{{ level == 0 ? '一级分类' : '二级分类' }}
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Category Tabs & Data Table Card -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-menu"></i>
                        分类列表
                    </span>
                    <div class="card-actions">
                        <el-tabs v-model="editableTabsValue" type="card" :closable="level != 0" @edit="handleTabsEdit"
                            @tab-click="tabsClick" style="margin: 0px auto 0;">
                            <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title"
                                :name="item.name" style="width: 91%;"></el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="card-content">
                    <div class="table-wrapper">
                        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="activityClassId" :max-height="tableHeight-20"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="tableData.length == 0" class="empty-data">
                            <i class="el-icon-inquiry"></i>
                            <p>暂无数据</p>
                        </div>
                    </div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                            :page-size="formDatas.pageSize"
                            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_form" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            :dialogTitle="'新增' + (level == 0 ? '一级分类' : '二级分类') + (theTitle ? ' @ ' + theTitle : '')"
            dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增" @confirm="handleAddConfirm"
            @cancel="handleCancel" @update:dialogVisible="val => addDialogVisible = val" />
        <aj-form-edit ref="edit_form" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val"
            :dialogTitle="'编辑' + (level == 0 ? '一级分类' : '二级分类') + (theTitle ? ' @ ' + theTitle : '')"
            labelWidth="100px" @confirm="handleEditConfirm" @cancel="handleCancel" />
    </div>
</template>

<script>
import { getAjActivityClassList, addAjActivityClass, updateAjActivityClass, deleteAjActivityClass } from "../../api/api";
export default {
    name: "activityCategory",
    data() {
        return {
            theTitle: '',
            addDialogVisible: false,
            editDialogVisible: false,
            accParentId: 0,
            editableTabsValue: '0',
            editableTabs: [{
                title: '一级分类',
                name: '0',
            }],
            tabIndex: 0,

            level: 0,
            key: 'activityClassId',
            form: {
                activityClassParentId: '',
                activityClassName: '',
                activityClassOrder: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHeight: 400,
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 60,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "activityClassName",
                    key: "activityClassName",
                    fixed: 'left',
                    title: "分类名称",
                    width: 200,
                    align: "center",
                },
                {
                    field: "activityClassOrder",
                    key: "activityClassOrder",
                    title: "排序",
                    align: "center",
                    width: 120,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span class="operation-buttons">
                                {
                                    row.activityClassLevel == 1
                                        ? <el-button
                                            size="mini"
                                            type="text"
                                            class="op-btn secondary"
                                            on-click={() => this.handleLevel(row)}
                                        >
                                            二级分类
                                        </el-button>
                                        : <span></span>
                                }
                                <el-button
                                    size="mini"
                                    type="text"
                                    class="op-btn"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    class="op-btn danger"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            formDatas: {
                activityClassParentId: 0,
                activityClassName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    computed: {
        formConfig() {
            // 一级分类
            if (this.level === 0) {
                return [
                    [{ label: '分类名称', prop: 'activityClassName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                    [{ label: '排序', prop: 'activityClassOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
                ];
            }
            // 二级分类
            return [
                [{ label: '分类名称', prop: 'activityClassName', type: 'input', placeholder: '请输入', span: 24, required: true, }],
                [{ label: '排序', prop: 'activityClassOrder', type: 'input', placeholder: '请输入', span: 24, required: false, }]
            ];
        }
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.handleResize();
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHeight = val - 300 - val * 0.04;
                }
            });
        },
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHeight = this.windheight - 300 - this.windheight * 0.04;
        this.getList();
    },
    methods: {
        handleResize() {
            this.$nextTick(() => {
                const bentoGrid = this.$el.querySelector('.bento-grid');
                if (bentoGrid) {
                    const gridHeight = bentoGrid.offsetHeight;
                    const cardPadding = 40;
                    const cardHeaderHeight = this.$el.querySelector('.card-header')?.offsetHeight || 0;
                    const paginationHeight = this.$el.querySelector('.table-pagination')?.offsetHeight || 0;

                    this.tableHeight = Math.max(
                        gridHeight - cardPadding - cardHeaderHeight - paginationHeight - 20,
                        200
                    );
                }
            });
        },
        resetSearch() {
            this.formDatas.activityClassName = '';
            this.partserch();
        },
        handleCancel() {
            this.form = {
                activityClassParentId: '',
                activityClassName: '',
                activityClassOrder: '',
            };
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该分类吗？',
                    type: 'danger'
                });
                deleteAjActivityClass({ activityClassId: row.activityClassId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                });
            } catch {
                this.$message.info('已取消');
            }
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            console.log('新增提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认新增分类吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                addAjActivityClass(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_form.cancelDiaLog();
                        this.form = {
                            activityClassParentId: '',
                            activityClassName: '',
                            activityClassOrder: '',
                        };
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                });
            } catch {
                this.$message.info('已取消');
            }
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该分类吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                updateAjActivityClass(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_form.cancelDiaLog();
                        this.form = {
                            activityClassParentId: '',
                            activityClassName: '',
                            activityClassOrder: '',
                        };
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                });
            } catch {
                this.$message.info('已取消');
            }
        },
        tabsClick(e) {
            this.editableTabsValue = e.name;
            this.tabIndex = this.editableTabsValue;
            this.level = this.tabIndex * 1;
            this.form.activityClassParentId = this.editableTabs[e.index * 1].activityClassParentId || 0;
            this.accParentId = this.editableTabs[e.index * 1].activityClassParentId || 0;
            this.formDatas.activityClassParentId = this.editableTabs[e.index * 1].activityClassParentId || 0;
            this.partserch();
        },
        handleTabsEdit(targetName, action) {
            if (action === 'remove') {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                            }
                        }
                    });
                }

                this.editableTabsValue = activeName;
                const tabarr = this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                this.tabIndex = tabarr[tabarr.length - 1].name;
                this.level = tabarr[tabarr.length - 1].name * 1;
                this.formDatas.activityClassParentId = tabarr[tabarr.length - 1].activityClassParentId || 0;
                this.partserch();
            }
        },
        handleLevel(row) {
            this.theTitle = row.activityClassName;
            this.level = 1;
            this.tabIndex = this.editableTabsValue = 1 + '';
            this.formDatas.activityClassParentId = this.accParentId = row.activityClassId;

            const s = {
                title: '二级分类',
                name: this.tabIndex,
                activityClassParentId: row.activityClassId
            };
            this.editableTabs.some((item, index) => {
                if (item.name === s.name) {
                    this.editableTabs.splice(index, 1, s);
                    this.partserch();
                    return true;
                } else if (index == this.editableTabs.length - 1 && item.name != s.name) {
                    this.editableTabs.push(s);
                    this.partserch();
                }
            });
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row));
            this.editDialogVisible = true;
            this.$nextTick(() => {
                this.form = data;
            });
        },
        BoxOpen() {
            this.form.activityClassParentId = this.accParentId;
            this.addDialogVisible = true;
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.activityClassId = row.activityClassId;
                    console.log(jsonObj);
                    updateAjActivityClass(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    });
                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {},
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];
            const selectedRowKeysCollection = this.selectedRowKeysCollection;
            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getAjActivityClassList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjActivityClassList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },
        getList() {
            getAjActivityClassList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: calc(100vh - 60px);
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
    animation: fadeIn 0.5s ease-in-out;
    height: 100%;
    display: flex;
    flex-direction: column;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-header:hover {
    box-shadow: 0 6px 28px rgba(139, 92, 246, 0.12), 0 3px 12px rgba(0, 0, 0, 0.06);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-icon:hover {
    transform: rotate(5deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
    color: white;
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
    position: relative;
    overflow: hidden;
}

.ai-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
}

.ai-btn:hover::before {
    left: 100%;
}

.ai-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(139, 92, 246, 0.45);
}

.ai-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 2px solid #e2e8f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #8b5cf6;
    color: #8b5cf6;
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.15);
}

/* Bento Grid */
.bento-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    flex: 1;
    min-height: 0;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #f59e0b;
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #10b981;
    background: white;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

/* Table Styles */
.table-card {
    width: 100%;
}

.card-content {
    padding: 4px 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.table-wrapper {
    flex: 1;
    overflow: hidden;
    min-height: 0;
}

.table-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f1f5f9;
    flex-shrink: 0;
}

/* Empty State */
.empty-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #94a3b8;
}

.empty-data i {
    font-size: 48px;
    margin-bottom: 12px;
}

.empty-data p {
    margin: 0;
    font-size: 14px;
}

/* Operation Buttons */
.operation-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;
}

.op-btn {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 6px;
    transition: all 0.2s;
}

.op-btn.secondary {
    color: #10b981;
    background: #ecfdf5;
}

.op-btn.secondary:hover {
    background: #10b981;
    color: white;
}

.op-btn.danger {
    color: #ef4444;
    background: #fef2f2;
}

.op-btn.danger:hover {
    background: #ef4444;
    color: white;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Tabs Style Override */
.card-actions ::v-deep .el-radio-button__inner {
    border: 1px solid #e2e8f0;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: white;
    color: #64748b;
}

.card-actions ::v-deep .el-radio-button__original:checked+.el-radio-button__inner {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-color: #10b981;
    color: white;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>
